import React from "react";
import { ScreenHeightLayout } from "components/layouts/ScreenHeightLayout";
import { ExercisePreview } from "components/ExercisePreview";

function ExercisePreviewPage(props) {
  return (
    <ScreenHeightLayout>
      <ExercisePreview index={parseInt(props.match.params.index)} />
    </ScreenHeightLayout>
  );
}

export { ExercisePreviewPage };
